import { Container, Box, Grid, Typography } from "@mui/material";
function Footer(){
    return(
        <Box  sx={{marginTop:20}}>
            <Container>
                <Typography textAlign="center" sx={{ fontFamily:'Prompt', color:'#939393'}}>copyright 2022 © Chertify</Typography>
            </Container>

        </Box>
    );
}
export default Footer